import { is8InchScreen } from '@/shared/stylesJS/breakpoints'
import Events8Inch from './components/Events8Inch'
import Events9Inch from './components/Events9Inch'

const Events = () => {
  return is8InchScreen ? <Events8Inch /> : <Events9Inch />
}

export { Events }
